import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-73049452"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-fixed tw-inset-0 tw-z-50 tw-flex tw-items-center tw-justify-center tw-bg-white/90 dark:tw-bg-black/90" }
const _hoisted_2 = { class: "tw-flex tw-items-center tw-justify-between tw-p-3" }
const _hoisted_3 = {
  key: 0,
  id: "studio-dialog-title",
  class: "tw-text-xs tw-font-medium dark:tw-text-white"
}
const _hoisted_4 = ["disabled"]
const _hoisted_5 = {
  key: 1,
  class: "tw-item-center tw-flex tw-items-center tw-justify-end tw-border-t tw-p-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TablerX = _resolveComponent("TablerX")!
  const _component_StudioButton = _resolveComponent("StudioButton")!

  return (_openBlock(), _createBlock(_Transition, {
    name: "fly-from-bottom",
    appear: "",
    onBeforeEnter: _cache[4] || (_cache[4] = ($event: any) => (_ctx.show = true))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_Transition, {
          name: "opacity",
          appear: "",
          onAfterLeave: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('close')))
        }, {
          default: _withCtx(() => [
            (_ctx.show)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(["tw-m-2 tw-flex tw-w-full tw-flex-col tw-rounded-2xl tw-border tw-bg-white tw-shadow-2xl dark:tw-bg-black", {
            'tw-h-fit-content tw-max-h-[90vh] tw-w-full tw-max-w-6xl tw-overflow-auto': _ctx.size === '2xlarge',
            'tw-h-full tw-max-w-4xl md:tw-max-h-[500px]': _ctx.size === 'xlarge',
            'tw-h-full tw-max-w-2xl md:tw-max-h-[500px]': _ctx.size === 'large',
            'tw-h-full tw-max-h-[90vh] tw-max-w-2xl md:tw-h-fit': _ctx.size === 'h-fit',
            'tw-max-w-xl': _ctx.size === 'medium',
            'tw-max-w-lg': _ctx.size === 'small',
            'tw-max-w-md': _ctx.size === 'xsmall'
          }])
                }, [
                  (_ctx.showCloseButton || _ctx.title || _ctx.$slots.title)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass({
              'tw-border-b': _ctx.title || _ctx.$slots.title
            })
                      }, [
                        _createElementVNode("div", _hoisted_2, [
                          (_ctx.title)
                            ? (_openBlock(), _createElementBlock("h2", _hoisted_3, _toDisplayString(_ctx.title), 1))
                            : _createCommentVNode("", true),
                          _renderSlot(_ctx.$slots, "title", {}, undefined, true),
                          (_ctx.showCloseButton)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 1,
                                disabled: _ctx.actionsDisabled,
                                type: "button",
                                class: "tw-ml-auto",
                                "data-testid": "studio-dialog-cross-button",
                                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleClose && _ctx.handleClose(...args)))
                              }, [
                                _createVNode(_component_TablerX, { class: "tw-ml-auto tw-h-4 tw-w-4 dark:tw-text-white" })
                              ], 8, _hoisted_4))
                            : _createCommentVNode("", true)
                        ])
                      ], 2))
                    : _createCommentVNode("", true),
                  _renderSlot(_ctx.$slots, "default", {}, undefined, true),
                  (_ctx.showFooter)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _renderSlot(_ctx.$slots, "footer-content", {}, undefined, true),
                        (_ctx.secondaryActionTitle)
                          ? (_openBlock(), _createBlock(_component_StudioButton, {
                              key: 0,
                              variant: _ctx.secondaryActionVariant,
                              trackingId: "studio-dialog-secondary-button",
                              disabled: _ctx.actionsDisabled || _ctx.secondaryActionDisabled,
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('secondaryAction')))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.secondaryActionTitle), 1)
                              ]),
                              _: 1
                            }, 8, ["variant", "disabled"]))
                          : _createCommentVNode("", true),
                        (_ctx.primaryActionTitle)
                          ? (_openBlock(), _createBlock(_component_StudioButton, {
                              key: 1,
                              variant: _ctx.primaryActionVariant,
                              trackingId: "studio-dialog-primary-button",
                              type: "submit",
                              class: "tw-ml-2",
                              disabled: _ctx.actionsDisabled || _ctx.primaryActionDisabled,
                              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('primaryAction')))
                            }, {
                              default: _withCtx(() => [
                                _renderSlot(_ctx.$slots, "primaryActionIcon", { className: _ctx.primaryActionIconClass }, undefined, true),
                                _createTextVNode(" " + _toDisplayString(_ctx.primaryActionTitle), 1)
                              ]),
                              _: 3
                            }, 8, ["variant", "disabled"]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ], 2))
              : _createCommentVNode("", true)
          ]),
          _: 3
        })
      ])
    ]),
    _: 3
  }))
}